import { useUnifiedAuth } from "@/backend/use-unified-auth";
import { useBackendPositions, type ClosePositionData } from "@/backend/hooks/use-backend-positions";
import type { Position } from "../programs/types";
import type { MarketSymbol } from "../constants";

// Re-export ClosePositionData for use by components
export type { ClosePositionData };

export const usePositions = () => {
  const { userId } = useUnifiedAuth();

  // Determine effective user ID (works for both wallet and email users)
  const effectiveUserId = userId;

  // Use centralized hook with WebSocket support
  // This hook provides fast close using local store (no re-fetching)
  const { 
    positions: backendPositions, 
    isLoading, 
    refetch,
    closePosition,
    closePositionAsync,
    isClosing,
  } = useBackendPositions(
    effectiveUserId ?? undefined
  );
  
  // Convert to the Position type expected by components
  const positions: Position[] = backendPositions.map(pos => ({
    id: pos.id,
    market: pos.market as MarketSymbol,
    side: pos.side,
    size: pos.size,
    entryPrice: pos.entryPrice,
    currentPrice: pos.currentPrice,
    leverage: pos.leverage,
    liquidationPrice: pos.liquidationPrice,
    unrealizedPnl: pos.unrealizedPnl,
    margin: pos.margin,
    collateral: pos.margin, // alias for Position type
    status: pos.status,
    openedAt: pos.openedAt.getTime(),
    takeProfit: pos.takeProfit,
    stopLoss: pos.stopLoss,
  }));

  return {
    positions,
    isLoading,
    closePosition,
    closePositionAsync,
    isClosing,
    refetch,
  };
};

